<template>
  <div>
    <div class="header-navbar-shadow"></div>
    <nav class="header-navbar main-header-navbar navbar-expand-lg navbar navbar-with-menu fixed-top ">
      <div class="navbar-wrapper">
        <div class="navbar-container content divContentStyle">
          <div class="navbar-collapse" id="navbar-mobile">
            <div class="mr-auto float-left bookmark-wrapper d-flex align-items-center">
              <ul class="nav navbar-nav">
                <li class="nav-item mobile-menu d-xl-none mr-auto"><a
                    class="nav-link nav-menu-main menu-toggle hidden-xs" href="#"><em class="ficon bx bx-menu"></em></a>
                </li>
                <ul class="nav navbar-nav bookmark-icons">
                  <li class="dropdown dropdown-language nav-item align-dropdown">
                    <a class="dropdown-toggle nav-link" id="dropdown-flag" href="#" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <em class="flag-icon"
                        :class="($store.state.language.language === 'English') ? 'flag-icon-us' : ($store.state.language.language === 'Arabic') ? 'flag-icon-sa' : 'flag-icon-pl'"></em><span
                        class="selected-language">{{ $store.state.language.language }}</span>
                    </a>

                    <div class="dropdown-menu " aria-labelledby="dropdown-flag">
                      <a class="dropdown-item" href="#" data-language="en" @click="setLanguage('English')">
                        <em class="flag-icon flag-icon-us mr-50"></em> {{ $t('English') }}
                      </a>
                      <a class="dropdown-item" href="#" data-language="ar" @click="setLanguage('Arabic')">
                        <em class="flag-icon flag-icon-sa mr-50"></em> {{ $t('Arabic') }}
                      </a>
                      <a class="dropdown-item" href="#" data-language="pl" @click="setLanguage('Polish')">
                        <em class="flag-icon flag-icon-pl mr-50"></em> {{ $t('Polish') }}
                      </a>
                    </div>
                  </li>
                </ul>
              </ul>
              <ul class="nav navbar-nav">
                <li class="nav-item d-none d-lg-block">
                  <div class="bookmark-input search-input">
                    <div class="bookmark-input-icon"><em class="bx bx-search primary"></em></div>
                    <input class="form-control input" type="text" :placeholder="$t('Explore Frest...')" tabindex="0"
                      data-search="template-search">
                    <ul class="search-list"></ul>
                  </div>
                </li>
              </ul>
            </div>
            <ul class="nav navbar-nav float-right">
              <li class="dropdown dropdown-user nav-item"><a class="dropdown-toggle nav-link dropdown-user-link"
                  href="#" data-toggle="dropdown">
                  <div class="user-nav d-sm-flex d-none"><span class="user-name">{{ user.name }}</span>
                    <span class="user-status text-muted capitalize" v-if="user.type == 'cloowner'">{{
                      $t('role_cloowner')
                    }}</span>
                    <span class="user-status text-muted capitalize" v-if="user.type == 'superadmin'">{{
                      $t('role_superadmin')
                    }}</span>
                    <span class="user-status text-muted capitalize" v-if="user.type == 'project_manager'">{{
                      $t('role_project_manager')
                    }}</span>
                    <span class="user-status text-muted capitalize" v-if="user.type == 'complaint_feedback_lead'">{{
                      $t('role_complaints_feedback_lead')
                    }}</span>
                    <span class="user-status text-muted capitalize" v-if="user.type == 'clopacto_user_success_lead'">{{
                      $t('role_pacto_user_success_lead')
                    }}</span>

                  </div>
                  <span>

                    <div class="custom-avatar">
                      <span class="avatar-name">{{ avatar.toUpperCase() }}</span>
                    </div>
                  </span>
                </a>
                <div class="dropdown-menu dropdown-menu-right pb-0">
                  <a class="dropdown-item" style="cursor: pointer;" @click="goProfile()">
                    <em class="bx bx-user mr-50"></em> {{ $t('Profile') }}
                  </a>
                  <div class="dropdown-divider mb-0"></div>
                  <a class="dropdown-item" href="#" @click="logout()"><em class="bx bx-power-off mr-50"></em>
                    {{ $t('Logout') }}</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { loadLocaleMessages, languageSelector } from '../i18n';
export default {
  name: 'Topbar',

  data() {
    return {
      user: this.$store.state.currentUser.user
    }
  },

  computed: {
    avatar() {
      let user = this.user
      let name = user.name.split(' ')[0]
      let surname = user.name.split(' ')[1]
      if (surname) {
        return name[0] + surname[0]
      } else {
        if (name[1]) {
          return name[0] + name[1]
        } else {
          return name[0]
        }
      }
    },
  },

  methods: {
    logout() {
      location.href = '/logout'
    },

    goProfile() {
      $("#nav-item-sidebar-profile").click()
      this.$router.push({ name: 'ProfilePage' })
    },

    setLanguage(lang) {
      console.log("langgg", lang)
      this.$store.dispatch('language/setLanguage', lang);
      this.$router.go()
    }
  }
}
</script>

<style scoped>
.custom-avatar {
  position: relative;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: #FF8302;
}

.avatar-name {
  margin-top: 1px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #fff;
}

.divContentStyle {
  padding-left: 0em;
  padding-right: 0em;
}

.align-dropdown {
  transform: translate(100em, 2px);
}

@media (max-width:1366px) {
  .align-dropdown {
    transform: translate(48em, 2px);
  }
}
</style>
